import _ from "lodash";
import get from "lodash/get";
import sum from "lodash/sum";
import { action, makeObservable } from "mobx";
import { Component } from "react";
import { getPatient } from "../serviceCalls";
import className, { cn } from "../shared/className";
import {
  formatDate,
  formatDateTime,
  formatTime,
} from "../shared/dateTimeUtils";
import frameDebounce from "../shared/frameDebounce";
import { MODULE_ID } from "../shared/moduleIds";
import { transformPatient } from "../entities/Patient";

export default class Widget extends Component {
  // eslint-disable-next-line no-unused-vars
  constructor(props = {}) {
    super(props);

    makeObservable(this, {
      getPatient: action,
    });

    const appStore = props.store;
    this.moduleId = sessionStorage.getItem("moduleId");
    this.asmpid = props.asmpid || props.match?.params.asmpid;
    if (this.asmpid && !props.patient) {
      if (!appStore.patient) {
        this.getPatient(this.asmpid);
      } else if (
        appStore.patientStore &&
        appStore.patient.asmpid !== this.asmpid
      ) {
        appStore.patient = appStore.patientStore.patient =
          appStore.patientStore.patients.find((p) => p.asmpid === this.asmpid);
      }
    }
    if (props.history?.location?.search) {
      this.searchParams = Object.fromEntries(
        new URLSearchParams(props.history.location.search),
      );
    }

    this.cn = cn;
    this.className = className;
    this.date = formatDate;
    this.time = formatTime;
    this.dateTime = formatDateTime;
    this.aClick = this.aClick.bind(this);
    this.frameDebounce = frameDebounce;
  }
  componentDidMount() {
    if (this.props.history) {
      this.removeHistoryListener = this.props.history.listen(this.observeRoute);
      window.addEventListener("refreshWidget", this.refresh, false);
    }
  }
  componentWillUnmount() {
    this.removeHistoryListener && this.removeHistoryListener();
    this.props.store.refreshWidget = _.noop;
    window.removeEventListener("refreshWidget", this.refresh);
  }

  componentDidCatch(error, info) {
    if (this.store) {
      this.store.error = error;
    }
    console.error("Widget Component error", error, info);
  }

  observeRoute() {
    // no-op abstract.
  }
  refresh() {}
  setRouteProps(routeProps) {
    ["asmpid", ...routeProps].forEach((prop) => {
      this[prop] = get(this, `props.match.params.${prop}`);
    });
  }
  async getPatient(asmpid) {
    const moduleId = sessionStorage.getItem("moduleId");
    const patientRes = await getPatient({
      moduleId,
      asmpid,
    });
    const patient = transformPatient(patientRes);
    restoreSnippetWorklistId(patient);
    patient.moduleSpecifics = patient?.moduleSpecificData?.find(
      (specific) => specific.moduleId.toString() === String(moduleId),
    );
    this.props.store.patient = patient;
  }

  log() {
    console.log(
      ...Array.prototype.map.apply(arguments, (arg) => {
        JSON.stringify(arg, null, 2);
      }),
    );
  }

  timerSamples = [];
  startTimer() {
    this.timerStartTime = performance.now();
  }
  checkTimer() {
    if (this.timerStartTime) {
      this.timerSamples.push(performance.now() - this.timerStartTime);
    }
    return sum(this.timerSamples) / this.timerSamples.length;
  }
  timer(fn) {
    this.startTimer();
    fn();
    console.log(this.checkTimer());
  }

  aClick(e) {
    e.preventDefault();
    if (e.target.disabled || e.target.classList.contains("disabled")) {
      return false;
    }
    this.historyPush(e.currentTarget.getAttribute("href"));
  }

  historyPush(path) {
    if (path !== this.props.location.pathname) {
      this.props.history.push(path);
    }
  }
}

const restoreSnippetWorklistId = (patient) => {
  try {
    const worklistPatient = JSON.parse(sessionStorage.snippetWorklistPatient);
    if (worklistPatient.asmpid === patient.asmpid) {
      const pmSpecifics = patient.moduleSpecificData.find(
        (s) => Number(s.moduleId) === Number(MODULE_ID.PATIENT_MONITORING),
      );
      const cached = {
        moduleId: MODULE_ID.PATIENT_MONITORING,
        snippetWorklistId: worklistPatient.snippetWorklistId,
      };
      if (pmSpecifics) {
        _.defaults(pmSpecifics, cached);
      } else {
        patient.moduleSpecificData.push(cached);
      }
    } else {
      sessionStorage.removeItem("snippetWorklistPatient");
    }
  } catch (e) {
    sessionStorage.removeItem("snippetWorklistPatient");
  }
};
